export enum AcceptWindow {
  H1 = 1,
  H6 = 6,
  H24 = 24,
}
